import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { ComboService } from '../../Model/Combo/combo.service';
import { CommonService } from '../../Model/Common/common.service';
import { ReimbursementformService } from '../../Model/Reimbursement/reimbursementform.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { Router } from '@angular/router';
import { ForceMobileVerificationService } from '../../Model/ForceMobileVerification/force-mobile-verification.service';

@Component({
  selector: 'app-force-mobile-verification',
  standalone: true,
  imports: [FormsModule, LoaderComponent, CommonModule, NgSelectModule, NgbModule, DataTablesModule],
  templateUrl: './force-mobile-verification.component.html',
  styleUrl: './force-mobile-verification.component.scss'
})
export class ForceMobileVerificationComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  BranchMaster: any[] = [];
  ClientMaster: any[] = [];
  SiteMaster: any[] = [];

  ESS_ForceMobileVerification: any[] = [];

  Detail = {
    SelectType: 'S',
    BranchId: null,
    ClientId: null,
    SiteId: null,
    EmpType: 'front',
    EmpCode: null,
  };

  public User: any = null;
  dtoptions: DataTables.Settings = {};
  constructor(private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private utility: UtilityService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private MobileVerification: ForceMobileVerificationService,
    private modalService: NgbModal,
  ) {
    this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };  
  }
  ngOnInit(): void {
    //this.Reimbursement.EmpMasterId = this.sessionService.GetUserDetails().UserId;
    this.ComboLoad('Branch');
  }

  Validate(form: any) {
    if ((this.Detail.BranchId == null || this.Detail.BranchId == '') && (this.Detail.EmpCode == null || this.Detail.EmpCode == '')) {
      this.toast.show({ message: 'Please select Branch or Enter EmpCode', type: toastTypeEnum.warning });
      return;
    }
    if (form.valid) {
      this.getData();
    }
    else {
      form.submitted = true;
    }
  }

  getData() {
    this.isDisabled = true;
    const Detail = {
      SelectType: this.Detail.SelectType,
      BranchId: this.Detail.BranchId,
      ClientId: this.Detail.EmpType === 'back' ? '' : this.Detail.ClientId,
      SiteId: this.Detail.EmpType === 'back' ? '' : this.Detail.SiteId,
      EmpType: this.Detail.EmpType,
      EmpCode: this.Detail.EmpCode,
    };
    this.MobileVerification.ESS_ForceMobileVerification(Detail).subscribe({
      next: (response) => {
        this.ESS_ForceMobileVerification = response.Table;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error: any) => {
        console.log(error);
        this.isDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client') ? this.Detail.BranchId : 0,
      'ClientId': (Combotype == 'Site') ? this.Detail.ClientId : 0,
      //'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.Detail.SiteId : 0,
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;

        } else if (Combotype == 'Client') {
          this.ClientMaster = response.ComboLoad;

        } else if (Combotype == 'Site') {
          this.SiteMaster = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false
      },
    });
  }

  onSelectChange(type: string) {
    if (type === 'Branch') {
      this.Detail.ClientId = null;
      this.Detail.SiteId = null;
      this.ESS_ForceMobileVerification = []
    }
    else if (type == 'Client') {
      this.Detail.SiteId = null;
      this.ESS_ForceMobileVerification = []
    }
    else if (type == 'Site') {
      this.ESS_ForceMobileVerification = []
    }
  }

  selectAll(event: any) {
    const checked = event.target.checked;
    this.ESS_ForceMobileVerification.forEach(shift => shift.IsMobileVerificationMandatory = checked);
  }
  selectRow(event: any, shift: any) {
    shift.IsMobileVerificationMandatory = event.target.checked;
  }
  async ESS_ReimbursementRequest_Insert() {
    await this.common.getPageRights();
    const ESS_ForceMobileVerification = this.ESS_ForceMobileVerification.map(site => {
      return {
        EmpMasterId: site.EmpMasterID,
        IsMobileVerificationMandatory: site.IsMobileVerificationMandatory,
      };
    });
    const Data = {
      SelectType: 'U',
      ESS_ForceMobileVerification: ESS_ForceMobileVerification
    };
    console.log(Data);
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then(result => {
      if (this.common.PageRight.IsEdit || this.common.PageRight.IsAdd) {
        if (result) {
          this.isDisabled = true;
          this.MobileVerification.ESS_ForceMobileVerification_insert(Data).subscribe({
            next: (response) => {
              if (response.Error_Code == '1') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.getData();
                  }
                });
              }
              else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }
  onChange(){
    this.ESS_ForceMobileVerification =[];
  }
}
